import { useState } from "react";

const NotFoundPage = () => {
  const [isAuthenticated] = useState(false); // Simulating auth state

  return (
    <div className="flex h-screen">
      {isAuthenticated && (
        <aside className="w-64 bg-gray-800 text-white p-4">
          <h2 className="text-xl font-bold">Sidebar</h2>
          <ul>
            <li className="mt-2">
              <a href="/" className="hover:underline">
                Home
              </a>
            </li>
            <li className="mt-2">
              <a href="/dashboard" className="hover:underline">
                Dashboard
              </a>
            </li>
          </ul>
        </aside>
      )}
      <main className="flex flex-1 flex-col items-center justify-center text-center p-4">
        <h1 className="text-6xl font-bold ">404</h1>
        <p className="text-xl text-gray-600 mt-4">Oops! Page not found.</p>
        {/* <a href="/" className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
          Go Home
        </a> */}
      </main>
    </div>
  );
};

export default NotFoundPage;
